'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formFieldUtils = require('../common/formFieldUtils');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var generateDefaultValue = function generateDefaultValue(item) {
  if (item.type === 'input') {
    return item.defaultValue;
  } else if (item.type === 'select' && Array.isArray(item.options)) {
    return item.options.find(function (option) {
      return option.value === item.defaultValue;
    });
  }
};

var convertSelectValue = function convertSelectValue(value) {
  if ((0, _lodash.isEmpty)(value)) return value;
  return {
    value: value.value,
    text: value.text || value.label,
    label: value.label || value.text
  };
};

var FormatInputField = (_temp = _class = function (_Field) {
  _inherits(FormatInputField, _Field);

  function FormatInputField(props) {
    _classCallCheck(this, FormatInputField);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _initialiseProps.call(_this);

    _this.initial = true;
    return _this;
  }

  FormatInputField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-format-input'
    });
  };

  // 获取组件值/子组件值


  FormatInputField.prototype.getValue = function getValue(key) {
    var value = (this.state.fieldData || {}).value;
    if ((0, _lodash.isEmpty)(value) || (0, _lodash.isEmpty)(key)) return value;
    var valueItem = value.find(function (item) {
      return item.name === key;
    });
    return valueItem && valueItem.value;
  };

  FormatInputField.prototype.getStyle = function getStyle(item) {
    var width = item.size && item.size + 'px';
    return {
      margin: '0 8px 8px 0',
      width: width
    };
  };

  FormatInputField.prototype.renderFormat = function renderFormat() {
    var _this2 = this;

    var format = this.props.format;

    var commonProps = this.getControlProps();
    if ((0, _lodash.isEmpty)(format)) return null;
    return format.map(function (item) {
      var itemValue = _this2.getValue(item.name);
      var style = _this2.getStyle(item);
      switch (item.type) {
        case 'label':
          return _react2.default.createElement(
            'span',
            { className: 'vc-format-input-label', title: item.label, style: style },
            item.label
          );
        case 'input':
          return _react2.default.createElement(_next.Input, _extends({}, commonProps, {
            hasClear: true,
            placeholder: item.placeholder,
            value: itemValue,
            style: style,
            onChange: function onChange(val) {
              _this2.onChange(item.name, val);
            }
          }));
        case 'select':
          return _react2.default.createElement(_next.Select, _extends({}, commonProps, {
            hasClear: true,
            placeholder: item.placeholder,
            value: convertSelectValue(itemValue),
            style: style,
            useDetailValue: true,
            dataSource: (0, _formFieldUtils.convertOptionsText)(item.options),
            onChange: function onChange(val) {
              _this2.onChange(item.name, convertSelectValue(val));
            }
          }));
      }
    });
  };

  FormatInputField.prototype.renderControl = function renderControl() {
    return _react2.default.createElement(
      'div',
      { className: 'vc-format-input-container' },
      this.renderFormat()
    );
  };

  return FormatInputField;
}(_vuFusionField2.default), _class.displayName = 'FormatInput', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  fieldId: null,
  label: null
}), _class.propTypes = {
  fieldId: _propTypes2.default.string,
  label: _propTypes2.default.string
}, _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), [{
  name: 'fieldData',
  formatIn: function formatIn(fieldData, props) {
    var format = props.getValue('format') || [];
    var value = [];
    // 从 format 中获取 defaultValue
    if (fieldData && fieldData.value && Array.isArray(fieldData.value)) {
      value = fieldData.value.filter(function (item) {
        return !!item;
      });
    }
    // 从 format 中补充 defaultValue
    if (format && Array.isArray(format)) {
      format.forEach(function (item) {
        if (!item.defaultValue) {
          return true;
        }
        var valueItem = value.find(function (valItem) {
          return valItem.name === item.name;
        });
        if (valueItem && !valueItem.value) {
          valueItem.value = generateDefaultValue(item);
        }
        if (!valueItem) {
          value.push({ name: item.name, value: generateDefaultValue(item) });
        }
      });
    }
    return { value: value };
  }
}]), _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onChange = function (name, value) {
    var onChange = _this3.props.onChange;

    var prevValue = _this3.getValue();
    var itemValue = { name: name, value: value };
    var nextValue = prevValue ? (0, _lodash.cloneDeep)(prevValue) : [];
    var prevIndex = nextValue.findIndex(function (item) {
      return item.name === name;
    });
    if (prevIndex > -1) {
      nextValue.splice(prevIndex, 1);
    }
    if (!(0, _lodash.isEmpty)(value)) {
      nextValue.push(itemValue);
    }
    onChange({ value: nextValue });
  };
}, _temp);
exports.default = FormatInputField;
module.exports = exports['default'];